import { useMutation, useQueryClient } from "@tanstack/react-query";
import { patchNotificationReadId } from "apis/notification";
import QUERY_KEYS from "config/queryKey";

const useNotificationReadIdMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => patchNotificationReadId(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.notifications] });
    },
  });
};

export default useNotificationReadIdMutation;
